import { WindowService } from '../../../../common/angular-shared/services/window/window.service';

export function authenticationInitializerProvider(windowService: WindowService) {
  return async () => {
    if (windowService && windowService.nativeWindow && windowService.nativeWindow.controller) {
      return windowService.nativeWindow.controller.getIsAuth0Enabled();
    }
  };
}
